
export enum SnippetViewType{
    LiquidTemplate,
    Value
}